/*
  Carter & Me — gift box cards.

  Pick an occasion, pick a colour, done. Selecting options resolves a real
  variant on the card and Add to bag posts straight to /cart/add.js, so the
  shopper never leaves the page.

  Colour is a variant, not a line item property, so the shade lands on the
  order line and the packing slip.

  Boxes with a Size option need both choices before a variant can resolve.
  The button stays disabled until it can, and its label names what is still
  missing rather than failing silently on click.
*/

(function () {
  function parseVariants(card) {
    // id::opt1//opt2::price::available
    return (card.dataset.variants || '')
      .split('|')
      .filter(Boolean)
      .map(function (row) {
        var parts = row.split('::');
        return {
          id: parts[0],
          options: (parts[1] || '').split('//'),
          price: parseInt(parts[2], 10),
          available: parts[3] === '1',
        };
      });
  }

  function money(cents) {
    // Match the store's format closely enough for an in-place price update;
    // the cart and checkout remain the source of truth.
    return 'R ' + (cents / 100).toLocaleString('en-ZA', { maximumFractionDigits: 0 });
  }

  function setup(card) {
    var variants = parseVariants(card);
    if (!variants.length) return;

    var optionCount = parseInt(card.dataset.optionCount, 10) || 1;
    var button = card.querySelector('[data-cm-gift-add]');
    var priceEl = card.querySelector('[data-cm-gift-price]');
    var errEl = card.querySelector('[data-cm-gift-err]');
    var idleLabel = button ? button.textContent.trim() : 'Add to bag';

    function chosen() {
      var out = [];
      for (var i = 0; i < optionCount; i++) {
        var picked = card.querySelector('[data-cm-gift-opt="' + i + '"]:checked');
        out.push(picked ? picked.value : null);
      }
      return out;
    }

    function match(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
    }

    // Name the first option that has not been answered yet.
    function missingLabel(sel) {
      for (var i = 0; i < optionCount; i++) {
        if (sel[i] === null) {
          var group = card.querySelectorAll('[data-cm-gift-opt="' + i + '"]');
          var label = group.length
            ? group[0].closest('.cm-giftcard__opt').querySelector('.cm-giftcard__optlabel')
            : null;
          // Read the raw option name off the data attribute, not the
          // visible text: the colour label is a prompt ("Choose your
          // colour") and composing from it gave "Choose your choose your
          // colour".
          var name = (label && label.dataset.cmGiftOptname) || 'option';
          return 'Choose your ' + name.toLowerCase();
        }
      }
      return null;
    }

    function sync() {
      var sel = chosen();

      // Strike out sizes that do not exist in the chosen colour.
      card.querySelectorAll('.cm-giftcard__size input').forEach(function (input) {
        var idx = parseInt(input.dataset.cmGiftOpt, 10);
        var trial = sel.slice();
        trial[idx] = input.value;
        var v = match(trial);
        input.disabled = !(v && v.available);
      });

      // Echo the chosen colour beside its label.
      card.querySelectorAll('[data-cm-gift-chosen]').forEach(function (el) {
        var idx = parseInt(el.dataset.cmGiftChosen, 10);
        el.textContent = sel[idx] ? ' · ' + sel[idx] : '';
      });

      var missing = missingLabel(sel);
      var variant = missing ? null : match(sel);

      if (variant && priceEl) priceEl.textContent = money(variant.price);

      if (!button) return;
      if (missing) {
        button.disabled = true;
        button.textContent = missing;
      } else if (!variant) {
        button.disabled = true;
        button.textContent = 'Unavailable';
      } else if (!variant.available) {
        button.disabled = true;
        button.textContent = 'Sold out';
      } else {
        button.disabled = false;
        button.textContent = idleLabel;
        button.dataset.variantId = variant.id;
      }
    }

    card.addEventListener('change', function (event) {
      if (event.target.matches('[data-cm-gift-opt]')) {
        if (errEl) errEl.hidden = true;
        sync();
      }
    });

    if (button) {
      button.addEventListener('click', async function () {
        var id = button.dataset.variantId;
        if (!id || button.disabled) return;

        var label = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding';

        try {
          var bag = document.querySelector('cart-notification');

          // Ask for the floating bag section in the SAME request. The
          // Section Rendering API is available on /cart/add.js via the
          // sections param; /cart.js?sections= is not, and silently returns
          // a cart with no sections key, which left the header count stale.
          var payload = { items: [{ id: Number(id), quantity: 1 }] };
          if (bag && typeof bag.getSectionsToRender === 'function') {
            payload.sections = bag.getSectionsToRender().map(function (s) { return s.id; });
            payload.sections_url = window.location.pathname;
          }

          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          if (!res.ok) throw new Error(await res.text());
          var state = await res.json();

          // Hand off to the floating bag so the count and the free shipping
          // progress bar update the same way they do everywhere else.
          if (bag && typeof bag.renderContents === 'function') {
            bag.renderContents(state);
          }

          button.textContent = 'Added';
          setTimeout(function () {
            button.textContent = label;
            button.disabled = false;
          }, 1600);
        } catch (e) {
          console.error('[cm-gift-grid] add failed', e);
          button.textContent = label;
          button.disabled = false;
          if (errEl) {
            errEl.textContent = 'Something went wrong. Please try again.';
            errEl.hidden = false;
          }
        }
      });
    }

    sync();
  }

  function init() {
    document.querySelectorAll('[data-cm-gift]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after a theme editor section reload.
  document.addEventListener('shopify:section:load', init);
})();
